/**
 * A single view mode option (e.g., grid, card, chart)
 */
export interface ViewModeOption {
  /**
   * Unique identifier for this view mode
   */
  id: string;

  /**
   * Display label (translation key)
   */
  label: string;

  /**
   * Icon class (e.g., 'fas fa-th')
   */
  icon?: string;

  /**
   * Whether this mode uses card view
   */
  isCardMode: boolean;
}

/**
 * A single sort option
 */
export interface SortOption {
  /**
   * Unique identifier for this sort option
   */
  id: string;

  /**
   * Display label (translation key)
   */
  label: string;

  /**
   * Icon class (e.g., 'fas fa-sort-alpha-down')
   */
  icon?: string;
}

/**
 * A single page size option
 */
export interface PageSizeOption {
  /**
   * The page size value (0 = show all)
   */
  value: number;

  /**
   * Display label (translation key)
   */
  label: string;

  /**
   * Icon class (optional)
   */
  icon?: string;
}

/**
 * Configuration for view mode controls
 */
export interface ViewModeConfig {
  /**
   * Available view modes
   */
  modes: ViewModeOption[];

  /**
   * Available sort options
   */
  sortOptions?: SortOption[];

  /**
   * Available page size options
   */
  pageSizeOptions?: PageSizeOption[];

  /**
   * Prefix for localStorage keys to avoid conflicts (optional, defaults to 'card-view')
   */
  storageKeyPrefix?: string;
}

/**
 * Current view state
 */
export interface ViewState {
  /**
   * Currently selected view mode ID
   */
  viewModeId: string;

  /**
   * Currently selected sort option ID
   */
  sortById?: string;

  /**
   * Current page size
   */
  pageSize?: number;
}
